import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lock",
  "use": "icon-lock-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-lock\">\n<path d=\"M74.7,48v10.7H53.3V48c0-5.9,4.8-10.7,10.7-10.7S74.7,42.1,74.7,48z M128,64c0,35.3-28.7,64-64,64S0,99.3,0,64S28.7,0,64,0\n\tS128,28.7,128,64z M85.3,58.7H80V48c0-8.8-7.2-16-16-16s-16,7.2-16,16v10.7h-5.3v32h42.7V58.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol